import { SliderModal, Text, Checkbox, Button, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box, ScrollView, TextArea } from 'native-base';
import React from 'react';
import { ActivityIndicator } from 'react-native';

import { Header } from './components/Header';

import { UnlockCustomerTypes } from '.';
export const ContainerDesktop: React.FC<UnlockCustomerTypes.Props> = ({
  chosenShippingType,
  handleCheckboxChange,
  handleTextAreaChange,
  selectedValues,
  textAreaInput,
  sendUnlockCustomer,
  unlockCustomerSendState,
  goBack,
}) => {
  const responsiveWidth = useBreakpointValue({
    base: 1,
    sm: 1,
    md: 0.42,
  });

  return (
    <SliderModal dismissWhenClickOutside={false} width={responsiveWidth}>
      <ScrollView showsVerticalScrollIndicator={false}>
        <VStack
          backgroundColor={'neutral.white'}
          p={Spacing['inline.xxs']}
          space={Spacing['stack.xxxs']}>
          <Header status="lock" />

          <VStack>
            <Text
              paddingBottom={Spacing['inset.nano']}
              fontSize={Typography['fontsize.md']}
              color={['neutral.dark']}
              fontWeight={Typography['fontweight.semibold']}>
              Canal de envio:
            </Text>
            <>
              <Checkbox
                hasError={!chosenShippingType}
                testId={'checkbox'}
                selectedValues={selectedValues}
                options={[{ label: 'E-mail', value: 'email' }]}
                onChange={handleCheckboxChange!}
              />
              {!chosenShippingType && (
                <Text
                  fontWeight={Typography['fontweight.regular']}
                  fontSize={Typography['fontsize.xxs']}
                  color={['feedback.error.default']}
                  position={'absolute'}
                  bottom={-4}>
                  Selecione uma opção
                </Text>
              )}
            </>
          </VStack>

          <VStack>
            <Text
              paddingY={Spacing['inset.nano']}
              color={['neutral.dark']}
              fontSize={Typography['fontsize.md']}
              fontWeight={Typography['fontweight.semibold']}>
              Informação adicional{' '}
              <Text
                fontSize={Typography['fontsize.xs']}
                color={['neutral.dark']}
                fontWeight={Typography['fontweight.regular']}>
                (opcional)
              </Text>
            </Text>

            <Box height={137}>
              <TextArea
                flex={1}
                borderRadius={Spacing['inline.nano']}
                backgroundColor={'#F9F9F9'}
                borderColor={'transparent'}
                _focus={{
                  backgroundColor: 'transparent',
                  borderColor: Color['brand.primary.principal'],
                  borderWidth: 1,
                }}
                _hover={{ borderColor: Color['brand.primary.principal'] }}
                caretHidden
                value={textAreaInput}
                placeholder="Adicione mais detalhes à solicitação."
                autoCompleteType={'off'}
                onChangeText={handleTextAreaChange}
              />
            </Box>

            <Text
              fontSize={Typography['fontsize.xs']}
              paddingY={Spacing['inset.sm']}
              color={['neutral.dark']}>
              Será enviado para cliente um link de uso único e expirará após a primeira tentativa de
              acesso. Após a confirmação, o contato será automaticamente removido desta lista.
            </Text>

            <HStack width={'100%'} alignItems={'center'} justifyContent={'space-between'}>
              <Button
                width={'41%'}
                maxWidth={160}
                backgroundColor="transparent"
                size="lg"
                onPress={goBack}>
                <Text
                  fontWeight={Typography['fontweight.semibold']}
                  fontSize={Typography['fontsize.md']}
                  color={['brand.primary.darkest']}>
                  CANCELAR
                </Text>
              </Button>
              <Button
                width={'41%'}
                maxWidth={160}
                onPress={() => sendUnlockCustomer()}
                backgroundColor={Color['feedback.success.default']}
                isDisabled={!chosenShippingType || unlockCustomerSendState.isLoading}
                size="lg">
                {unlockCustomerSendState.isLoading ? (
                  <ActivityIndicator size={'small'} color={Color['brand.primary.principal']} />
                ) : (
                  <Text
                    fontWeight={Typography['fontweight.semibold']}
                    fontSize={Typography['fontsize.md']}
                    color={['neutral.white']}>
                    CONFIRMAR
                  </Text>
                )}
              </Button>
            </HStack>
          </VStack>
        </VStack>
      </ScrollView>
    </SliderModal>
  );
};
